// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ISearchFileDto
 */
export interface ISearchFileDto {
    /**
     * 
     * @type {string}
     * @memberof ISearchFileDto
     */
    file_name?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ISearchFileDto
     */
    organization_ids?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ISearchFileDto
     */
    uploaded_by?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ISearchFileDto
     */
    file_types?: Array<ISearchFileDtoFileTypesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ISearchFileDto
     */
    file_processing_status_types?: Array<ISearchFileDtoFileProcessingStatusTypesEnum>;
    /**
     * 
     * @type {Date}
     * @memberof ISearchFileDto
     */
    created_date_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ISearchFileDto
     */
    created_date_to?: Date;
    /**
     * 
     * @type {number}
     * @memberof ISearchFileDto
     */
    duplicate_file_id?: number;
}

/**
* @export
* @enum {string}
*/
export enum ISearchFileDtoFileTypesEnum {
    CENSUS = 'CENSUS',
    ENROLLMENT = 'ENROLLMENT',
    CONTRIBUTION = 'CONTRIBUTION',
    MD = 'MD',
    ED = 'ED',
    BAI2 = 'BAI2',
    BR = 'BR',
    MIXED = 'MIXED',
    CIP = 'CIP',
    ISO_302 = 'ISO_302',
    UNKNOWN = 'UNKNOWN',
    PGP_BAI2 = 'PGP_BAI2',
    CARRIER = 'CARRIER',
    ACH = 'ACH',
    CHECK_PAID = 'CHECK_PAID',
    CHECK_CANCELLED = 'CHECK_CANCELLED',
    DEPENDENT = 'DEPENDENT',
    BALANCE_ADJUSTMENT = 'BALANCE_ADJUSTMENT'
}
/**
* @export
* @enum {string}
*/
export enum ISearchFileDtoFileProcessingStatusTypesEnum {
    INITIATED = 'INITIATED',
    UPLOADED = 'UPLOADED',
    PARSED = 'PARSED',
    VALIDATED = 'VALIDATED',
    APPROVED = 'APPROVED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    QUALITY_GATES_FAILED = 'QUALITY_GATES_FAILED',
    ERROR = 'ERROR',
    DUPLICATE = 'DUPLICATE',
    CANCELLED = 'CANCELLED'
}


/**
 * Check if a given object implements the ISearchFileDto interface.
 */
export function instanceOfISearchFileDto(value: object): value is ISearchFileDto {
    return true;
}

export function ISearchFileDtoFromJSON(json: any): ISearchFileDto {
    return ISearchFileDtoFromJSONTyped(json, false);
}

export function ISearchFileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISearchFileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'file_name': json['file_name'] == null ? undefined : json['file_name'],
        'organization_ids': json['organization_ids'] == null ? undefined : json['organization_ids'],
        'uploaded_by': json['uploaded_by'] == null ? undefined : json['uploaded_by'],
        'file_types': json['file_types'] == null ? undefined : json['file_types'],
        'file_processing_status_types': json['file_processing_status_types'] == null ? undefined : json['file_processing_status_types'],
        'created_date_from': json['created_date_from'] == null ? undefined : (new Date(json['created_date_from'])),
        'created_date_to': json['created_date_to'] == null ? undefined : (new Date(json['created_date_to'])),
        'duplicate_file_id': json['duplicate_file_id'] == null ? undefined : json['duplicate_file_id'],
    };
}

export function ISearchFileDtoToJSON(json: any): ISearchFileDto {
    return ISearchFileDtoToJSONTyped(json, false);
}

export function ISearchFileDtoToJSONTyped(value?: ISearchFileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file_name': value['file_name'],
        'organization_ids': value['organization_ids'],
        'uploaded_by': value['uploaded_by'],
        'file_types': value['file_types'],
        'file_processing_status_types': value['file_processing_status_types'],
        'created_date_from': value['created_date_from'] == null ? undefined : ((value['created_date_from']).toISOString()),
        'created_date_to': value['created_date_to'] == null ? undefined : ((value['created_date_to']).toISOString()),
        'duplicate_file_id': value['duplicate_file_id'],
    };
}

